import contentTranslations from './contentTranslations';
import homeSectionTranslations from './homeSectionTranslations';
import howItWorksTranslations from './howItWorksTranslations';
import coreFeatureTranslations from './coreFeatureTranslations';
import coreFeatureLongformParityTranslations from './coreFeatureLongformParityTranslations';
import coreFeatureRemainingTranslations from './coreFeatureRemainingTranslations';
import coreFeatureRemainingLongformParityTranslations from './coreFeatureRemainingLongformParityTranslations';
import featuresPageTranslations from './featuresPageTranslations';
import ecosystemPageTranslations from './ecosystemPageTranslations';
import ecosystemPageTranslations2 from './ecosystemPageTranslations2';
import ecosystemLongformParityTranslations from './ecosystemLongformParityTranslations';
import ecosystemExactParityTranslations from './ecosystemExactParityTranslations';
import academyPageTranslations from './academyPageTranslations';
import academyPageTranslations2 from './academyPageTranslations2';
import academyLongformParityTranslations from './academyLongformParityTranslations';
import clubsPageTranslations from './clubsPageTranslations';
import clubsLongformParityTranslations from './clubsLongformParityTranslations';
import clubsPhysicalDropsParityTranslations from './clubsPhysicalDropsParityTranslations';
import childSafetyPageTranslations from './childSafetyPageTranslations';
import childSafetyLongformParityTranslations from './childSafetyLongformParityTranslations';
import safetyResearchTranslations from './safetyResearchTranslations';
import safetyResearchLongformParityTranslations from './safetyResearchLongformParityTranslations';
import safetyResearchExactParityTranslations from './safetyResearchExactParityTranslations';
import parentsPageTranslations from './parentsPageTranslations';
import parentsLongformParityTranslations from './parentsLongformParityTranslations';
import aboutPageTranslations from './aboutPageTranslations';
import aboutLongformParityTranslations from './aboutLongformParityTranslations';
import ventureStudioPageTranslations from './ventureStudioPageTranslations';
import ventureStudioLongformParityTranslations from './ventureStudioLongformParityTranslations';
import ventureStudioExactParityTranslations from './ventureStudioExactParityTranslations';
import ventureStudioFinalCtaParityTranslations from './ventureStudioFinalCtaParityTranslations';
import giftPageTranslations from './giftPageTranslations';
import finalVisibleGapTranslations from './finalVisibleGapTranslations';
import testingPageTranslations from './testingPageTranslations';
import testingFullParityTranslations from './testingFullParityTranslations';
import contactPageTranslations from './contactPageTranslations';
import contactTestingLongformParityTranslations from './contactTestingLongformParityTranslations';
import blogTranslations from './blogTranslations';
import blogLongformTranslations from './blogLongformTranslations';
import childSafetyPolicyTranslations from './childSafetyPolicyTranslations';
import childSafetyPolicyLongformTranslations from './childSafetyPolicyLongformTranslations';
import childSafetyPolicyLongformFr from './childSafetyPolicyLongformFr';
import childSafetyPolicyLongformKo from './childSafetyPolicyLongformKo';
import childSafetyPolicyLongformAr from './childSafetyPolicyLongformAr';
import communityGuidelinesTranslations from './communityGuidelinesTranslations';
import communityGuidelinesLongformTranslations from './communityGuidelinesLongformTranslations';
import dataLifecycleTranslations from './dataLifecycleTranslations';
import dataLifecycleLongformTranslations from './dataLifecycleLongformTranslations';
import dataRetentionExactParityTranslations from './dataRetentionExactParityTranslations';
import termsPrivacyTranslations from './termsPrivacyTranslations';
import reportCopyrightTranslations from './reportCopyrightTranslations';
import userContentCopyrightLongformTranslations from './userContentCopyrightLongformTranslations';
import termsLongformTranslations from './termsLongformTranslations';
import termsFullParityTranslations from './termsFullParityTranslations';
import privacyLongformTranslations from './privacyLongformTranslations';
import privacyFullParityTranslations from './privacyFullParityTranslations';
import reportHandlingLongformTranslations from './reportHandlingLongformTranslations';
import miscExactParityTranslations from './miscExactParityTranslations';
import koQualityOverrides from './koQualityOverrides';
import finalCoverageGapOverrides from './finalCoverageGapOverrides';
import pageFragmentExactParityTranslations from './pageFragmentExactParityTranslations';
import legalOctober2026CommunityTranslations from './legalOctober2026CommunityTranslations';
import legalOctober2026ChildSafetyTranslations from './legalOctober2026ChildSafetyTranslations';
import legalOctober2026RetentionTranslations from './legalOctober2026RetentionTranslations';
import legalOctober2026TermsTranslations from './legalOctober2026TermsTranslations';
import legalOctober2026CopyrightTranslations from './legalOctober2026CopyrightTranslations';
import legalOctober2026PrivacyPart1 from './legalOctober2026PrivacyPart1';
import legalOctober2026PrivacyPart2 from './legalOctober2026PrivacyPart2';
import legalOctober2026PrivacyPart3 from './legalOctober2026PrivacyPart3';
import legalOctober2026PrivacyPart4 from './legalOctober2026PrivacyPart4';
import legalOctober2026PrivacyPart5 from './legalOctober2026PrivacyPart5';

const translationSources = [
  contentTranslations,
  homeSectionTranslations,
  howItWorksTranslations,
  coreFeatureTranslations,
  coreFeatureLongformParityTranslations,
  coreFeatureRemainingTranslations,
  coreFeatureRemainingLongformParityTranslations,
  featuresPageTranslations,
  ecosystemPageTranslations,
  ecosystemPageTranslations2,
  ecosystemLongformParityTranslations,
  ecosystemExactParityTranslations,
  academyPageTranslations,
  academyPageTranslations2,
  academyLongformParityTranslations,
  clubsPageTranslations,
  clubsLongformParityTranslations,
  clubsPhysicalDropsParityTranslations,
  childSafetyPageTranslations,
  childSafetyLongformParityTranslations,
  safetyResearchTranslations,
  safetyResearchLongformParityTranslations,
  safetyResearchExactParityTranslations,
  parentsPageTranslations,
  parentsLongformParityTranslations,
  aboutPageTranslations,
  aboutLongformParityTranslations,
  ventureStudioPageTranslations,
  ventureStudioLongformParityTranslations,
  ventureStudioExactParityTranslations,
  ventureStudioFinalCtaParityTranslations,
  giftPageTranslations,
  finalVisibleGapTranslations,
  testingPageTranslations,
  testingFullParityTranslations,
  contactPageTranslations,
  contactTestingLongformParityTranslations,
  blogTranslations,
  blogLongformTranslations,
  childSafetyPolicyTranslations,
  childSafetyPolicyLongformTranslations,
  childSafetyPolicyLongformFr,
  childSafetyPolicyLongformKo,
  childSafetyPolicyLongformAr,
  communityGuidelinesTranslations,
  communityGuidelinesLongformTranslations,
  dataLifecycleTranslations,
  dataLifecycleLongformTranslations,
  dataRetentionExactParityTranslations,
  termsPrivacyTranslations,
  reportCopyrightTranslations,
  userContentCopyrightLongformTranslations,
  termsLongformTranslations,
  termsFullParityTranslations,
  privacyLongformTranslations,
  privacyFullParityTranslations,
  reportHandlingLongformTranslations,
  miscExactParityTranslations,
  koQualityOverrides,
  finalCoverageGapOverrides,
  pageFragmentExactParityTranslations,
  legalOctober2026CommunityTranslations,
  legalOctober2026ChildSafetyTranslations,
  legalOctober2026RetentionTranslations,
  legalOctober2026TermsTranslations,
  legalOctober2026CopyrightTranslations,
  legalOctober2026PrivacyPart1,
  legalOctober2026PrivacyPart2,
  legalOctober2026PrivacyPart3,
  legalOctober2026PrivacyPart4,
  legalOctober2026PrivacyPart5,
];

export default translationSources;
